import { render, staticRenderFns } from "./AnggotaUmum.vue?vue&type=template&id=25f8fae8&scoped=true&"
import script from "./AnggotaUmum.vue?vue&type=script&lang=js&"
export * from "./AnggotaUmum.vue?vue&type=script&lang=js&"
import style0 from "./AnggotaUmum.vue?vue&type=style&index=0&id=25f8fae8&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f8fae8",
  null
  
)

export default component.exports